import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { FriendsService } from '../../../../shared/services/friends.service';
import { Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { DecryptionService } from '../../../../shared/services/decryption.service';

@Component({
  selector: 'app-friends',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './friends.component.html',
  styleUrl: './friends.component.scss',
})
export class FriendsComponent implements OnInit {
  friendDetails = '';
  findFriendData: any;
  requestSentdata: any;
  accrejRequest: any;
  findplayer: any;
  private playertimer?: Subscription;
  private friendtimer?: Subscription;
  removeConfirmFriend = 'none';
  Removeusername: any;
  removeIndex!: number;
  devices = ['alphabetical', 'joinDate', 'lastOnline'];

  constructor(
    private friendData: FriendsService,
    private router: Router,
    private toastr: ToastrService, private decryptionApi: DecryptionService
  ) { }

  ngOnInit(): void {
    this.findData('');
    this.requestdata();
  }

  findData(data: string) {
    if (this.playertimer) {
      this.playertimer.unsubscribe();
    }

    if (this.friendtimer) {
      this.friendtimer.unsubscribe();
    }

    this.friendtimer = timer(1000)
      .pipe(switchMap(() => this.friendData.findfriend({ query: data })))
      .subscribe({
        next: (res: any) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.findFriendData = jsondecrpt;
        },
        error: (error) => {
          if (error.error.success === false) {
            this.findFriendData = [];
          }
        },
      });

    if (data) {
      this.playertimer = timer(1000)
        .pipe(switchMap(() => this.friendData.findplayer({ query: data })))
        .subscribe({
          next: (res: any) => {
            const decrypt=  this.decryptionApi.decrypt(res.payload);
            const jsondecrpt=JSON.parse(decrypt);
            this.findplayer = jsondecrpt;
          },
          error: (error) => {
            if (error.error.success === false) {
              this.findplayer = [];
            }
          },
        });
    } else {
      this.findplayer = null;
    }
  }

  ngOnDestroy() {
    if (this.playertimer) {
      this.playertimer.unsubscribe();
    }
    if (this.friendtimer) {
      this.friendtimer.unsubscribe();
    }
  }

  requestdata() {
    this.friendData.sentrequestlist().subscribe((Res) => {
      const decrypt=  this.decryptionApi.decrypt(Res.payload);
      const jsondecrpt=JSON.parse(decrypt);
      this.requestSentdata = jsondecrpt.sfr;
      this.accrejRequest = jsondecrpt.rfr;
    });
  }

  cancelrequest(user: any, index: number) {
    const inputValue = {
      username: user.username,
    };

    this.friendData.sentrequestCancel(inputValue).subscribe((res) => {
      if (res.success) {
        this.requestSentdata.splice(index, 1);
      }
    });
  }

  friendrequest(data: any, index: number) {
    const inputValue = {
      username: data.username,
    };

    this.friendData.friendReqeust(inputValue).subscribe((res) => {
      if (res.success) {
        this.findplayer.splice(index, 1);
        this.requestSentdata.push(data);
        this.toastr.info(res.messages);
      }
    });
  }

  removeCofirm(data: any, index: number) {
    this.removeConfirmFriend = 'block';
    this.Removeusername = data.username;
    this.removeIndex = index;
  }

  notremoveFriend() {
    this.removeConfirmFriend = 'none';
  }

  removeFriend() {
    const inputValue = {
      username: this.Removeusername,
    };

    this.friendData.removefriend(inputValue).subscribe((res) => {
      if (res.success) {
        this.findFriendData.splice(this.removeIndex, 1);
        this.removeConfirmFriend = 'none';
        this.toastr.error(res.messages);
      }
    });
  }

  acceptrequest(user: any, index: number) {
    const inputValue = {
      username: user.username,
    };

    this.friendData.acceptfriend(inputValue).subscribe((res) => {
      if (res.success) {
        this.accrejRequest.splice(index, 1);
        this.findFriendData.push(user);
        this.toastr.success(res.messages);
      }
    });
  }

  rejectrequest(user: string, index: number) {
    const inputValue = {
      username: user,
    };
    this.friendData.rejectfriend(inputValue).subscribe((res) => {
      this.accrejRequest.splice(index, 1);
      this.toastr.error(res.messages);
    });
  }

  onChange(deviceValue: any) {
    const data = { query: this.friendDetails };
    this.friendData.findsortfriend(deviceValue.target.value, data).subscribe({
      next: (res) => {
        const decrypt=  this.decryptionApi.decrypt(res.payload);
        const jsondecrpt=JSON.parse(decrypt);
        this.findFriendData = jsondecrpt;
      },
    });
    if (this.friendDetails) {
      this.friendData.findsortPlayer(deviceValue.target.value, data).subscribe({
        next: (res) => {
          const decrypt=  this.decryptionApi.decrypt(res.payload);
          const jsondecrpt=JSON.parse(decrypt);
          this.findplayer = jsondecrpt;
        },
      });
    }
  }

  profilememberDetails(username: string) {
    this.router.navigate(['/profile', username]);
  }
}
